import getFulfilmentIds from "../../../../../../getFulfilmentIds";
import getFulfilmentType, {
  FULFILMENT_TYPE
} from "../../../../../../getFulfilmentType";

const getDtcLabelsCount = savedItemProducts =>
  savedItemProducts.filter(({ source, seller }) => {
    const { sourceId, sellerId } = getFulfilmentIds({ source, seller });

    return (
      getFulfilmentType({ sourceId, sellerId }) ===
      FULFILMENT_TYPE.PARTNER_FULFILS
    );
  }).length;

export default getDtcLabelsCount;
